module.exports = __webpack_public_path__ + "img/img_throw_1@2x.621d5bc2.png";